'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const User = ({ height = '26px', width = '26px', fill = 'none', ...rest }) => {
    return (_jsx(BaseIcon, { viewBox: '0 0 26 26', height, width, fill, ...rest, children: _jsxs("g", { fill: fill, stroke: 'currentColor', strokeWidth: '1.5', transform: 'translate(6 6)', children: [_jsx("circle", { cx: '6.32', cy: '3.39', r: '3.26' }), _jsx("path", { d: 'M.13 12.24V8.37A.77.77 0 0 1 .9 7.6h10.87a.77.77 0 0 1 .77.77v3.83' })] }) }));
};
//# sourceMappingURL=User.js.map